import React from 'react';
import {useLocation} from 'react-router-dom';
import {Link} from '../components/Link';
import {SetState} from './types/Global';
import {saveHomeScrollY} from './helpers/scrollMemory';

type LayoutType = {
    children: React.ReactNode;
};

type PageLinkType = {
    link: string;
    children: React.ReactNode;
    setPointer: SetState<boolean>;
    setLeaving: SetState<boolean>;
    label?: string;
    click?: () => void;
};

const Layout: React.FC<LayoutType> = ({children}) => {
    return <React.Fragment>{children}</React.Fragment>;
};

// TODO FIX
export const PageLink: React.FC<PageLinkType> = ({label = undefined, setPointer, link, children, setLeaving, click}) => {
    const location = useLocation();
    return (
        <Link
            setPointer={setPointer}
            onClick={() => {
                setPointer(false);
                window.removeEventListener('mousemove', event => {});
                // Only remember the scroll position when actually leaving home - a
                // click from the project page (e.g. the "work" nav link) must not
                // clobber it with the project's own (irrelevant) scroll position.
                if (location.pathname === '/') {
                    saveHomeScrollY(window.scrollY);
                }
                window.scrollTo(0, 0);
                setLeaving(true);
                click && click();
            }}
            aria-label={label}
            to={link}>
            {children}
        </Link>
    );
};

export default Layout;
